<template>
  <div class="flex justify-between align-middle" >
    <div>
      <p class="text-xl font-medium">{{ product.title }}</p>
    </div>
    <p class="text-xl font-medium">
        {{ useFormatMoney(product.price) }}
    </p>
  </div>
</template>

<script lang="ts" setup>
import type {ProductDetails} from "~/models/product";

const {product } = defineProps<{
  product: ProductDetails
}>()


const shopHandle = computed(() => {
  if (!shop) return null
  return shop.handle
})

const productId = computed(() => {
  return product.id.split("/").pop()
})
</script>

<style lang="css" scoped>
</style>